
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { getBookingLocations } from "../../../../../api/services";
import { FormAutocomplete } from "../../../../../components/fields";
import { ReactQueryKey } from "../../../../../types";
import { IFormValuesBookingsFilter } from "../../../types";

const FormPickupLocations = () => {

    const { t } = useTranslation('booking');

    const locationsQuery = useQuery({
        queryKey: [ReactQueryKey.BookingLocations, {tenants:[],dealers:[]}],
        queryFn: () => getBookingLocations({tenants:[],dealers:[]}),
        enabled: false
    });

    const handleOnOpen = () => {
        if(locationsQuery.data?.locations == undefined) 
            locationsQuery.refetch();
    }

    return (
        <FormAutocomplete<IFormValuesBookingsFilter>
            name="pickupLocations"
            label={t('label.pickupLocations')}
            options={locationsQuery.data?.locations || []}
            loading={locationsQuery.isLoading}
            isOptionEqualToValue={(option, value) => option?.id === value?.id}
            getOptionLabel={(option) => option.label}
            multiple
            onOpen={handleOnOpen}
        />
    );
};

export default FormPickupLocations;